import styled, { css } from 'styled-components';

const tonos = {
  sage: css`
    background: ${({ theme }) => theme.colors.sageLight};
    color: ${({ theme }) => theme.colors.sageDeep};
  `,
  arena: css`
    background: ${({ theme }) => theme.colors.sand};
    color: ${({ theme }) => theme.colors.textMuted};
  `,
  exito: css`
    background: ${({ theme }) => theme.colors.successLight};
    color: ${({ theme }) => theme.colors.success};
  `,
  alerta: css`
    background: ${({ theme }) => theme.colors.warningLight};
    color: ${({ theme }) => theme.colors.warning};
  `,
  peligro: css`
    background: ${({ theme }) => theme.colors.dangerLight};
    color: ${({ theme }) => theme.colors.danger};
  `,
};

// Etiqueta corta: cupo disponible, estados de reserva, niveles, etc.
const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.2rem 0.7rem;
  border-radius: ${({ theme }) => theme.radii.pill};
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  white-space: nowrap;
  ${({ $tono }) => tonos[$tono] || tonos.sage}
`;

export default Badge;
